import React from "react";
import NavBar from "./NavBar";
import UserSideBar from "./UserSideBar";

import "./userProfile.css";

function UserProfile() {
  return (
    <>
      <NavBar />
      <div style={{ marginTop: "7rem" }} className="container">
        <div className="row">
          <div className="col-6 col-lg-3">
            <UserSideBar />
          </div>
        </div>
      </div>
    </>
  );
}

export default UserProfile;
